<template>
  <div class="show-pwd" :class="{ active: isShow }" @click="togglePwd"></div>
</template>

<script>
export default {
  name: 'show-pwd',
  props: {
    graph: { type: String, default: '' },
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    // 显隐密码
    togglePwd() {
      this.isShow = !this.isShow;
      this.$emit('togglePwd', this.isShow);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';

.show-pwd {
  position: absolute;
  right: 0;
  top: 9px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 3;
  background: url('../imgs/pwd@2x.png') center no-repeat;
  background-size: 21px auto;
  &.active {
    background-image: url('../imgs/pwd-on@2x.png');
    background-size: 24px auto;
  }
}
</style>
